/* RESPONSIBLE TEAM: team-frontend-tech */

import Service from '@ember/service';
import OpenCenteredWindow from 'embercom/lib/open-centered-window';

export default class OpenCenteredWindowService extends Service {
  setup(url: string, height: number, width: number, name: string) {
    return OpenCenteredWindow(url, height, width, name);
  }
}
